import React from "react"

const SummaryRow = ({ className = undefined, label, children = undefined }) => {
  return (
    <div className={`grid grid-cols-12 gap-4 mb-2 ${className}`}>
      <div className="col-span-4">
        <span className="vt-summary-label">{label}</span>
      </div>
      <div className="col-span-8">
        <span className="vt-summary-value">{children}</span>
      </div>
    </div>
  )
}

export default SummaryRow
